module.exports = __webpack_public_path__ + "img/MessageIcon.ee8d8e24.png";